//Hardcoded factors with iconPath as well as displayNames
export const factors = [
  {
    rank: 1,
    factor: "score_commute",
    displayName: "Commute Time",
    iconPath: `M47.8,11.6c-9.8-9.8-25.6-9.8-35.4,0s-9.8,25.6,0,35.4c9.8,9.8,25.6,9.8,35.4,0C57.6,37.2,57.6,21.3,47.8,11.6z M10.2,30.2
	C9.5,30.3,8.9,29.7,9,29c0.1-0.4,0.4-0.7,0.8-0.8c0.7-0.1,1.3,0.5,1.1,1.1C10.8,29.8,10.5,30.1,10.2,30.2z M13.3,40.1
	c-0.5,0.4-1.3,0.2-1.5-0.4c-0.1-0.4,0-0.8,0.3-1c0.5-0.4,1.3-0.2,1.5,0.4C13.7,39.4,13.6,39.8,13.3,40.1z M13.6,19.4
	c-0.2,0.6-1,0.9-1.5,0.4c-0.3-0.3-0.4-0.7-0.3-1c0.2-0.6,1-0.9,1.5-0.4C13.6,18.7,13.7,19.1,13.6,19.4z M21,47
	c-0.2,0.6-1,0.9-1.5,0.4c-0.3-0.3-0.4-0.7-0.3-1c0.2-0.6,1-0.9,1.5-0.4C21,46.3,21.1,46.7,21,47z M20.7,12.5
	c-0.5,0.4-1.3,0.2-1.5-0.4c-0.1-0.4,0-0.8,0.3-1c0.5-0.4,1.3-0.2,1.5,0.4C21.1,11.8,21,12.2,20.7,12.5z M25,21.6
	c-0.3-0.5-0.1-1,0.3-1.3c0.5-0.3,1-0.1,1.3,0.3l4.1,7.5c0.3,0.6,0.5,1.2,0.5,1.8v14.7c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1V30
	c0-0.3-0.1-0.6-0.2-0.9C29,29,25,21.6,25,21.6z M30.4,50.4c-0.7,0.1-1.3-0.5-1.1-1.1c0.1-0.4,0.4-0.7,0.8-0.8
	c0.7-0.1,1.3,0.5,1.1,1.1C31,50,30.7,50.3,30.4,50.4z M30.4,10c-0.7,0.1-1.3-0.5-1.1-1.1c0.1-0.4,0.4-0.7,0.8-0.8
	c0.7-0.1,1.3,0.5,1.1,1.1C31,9.6,30.7,9.9,30.4,10z M40.9,47.4c-0.5,0.4-1.3,0.2-1.5-0.4c-0.1-0.4,0-0.8,0.3-1
	c0.5-0.4,1.3-0.2,1.5,0.4C41.3,46.8,41.2,47.2,40.9,47.4z M41.2,12.1c-0.2,0.6-1,0.9-1.5,0.4c-0.3-0.3-0.4-0.7-0.3-1
	c0.2-0.6,1-0.9,1.5-0.4C41.2,11.3,41.3,11.7,41.2,12.1z M48.6,39.6c-0.2,0.6-1,0.9-1.5,0.4c-0.3-0.3-0.4-0.7-0.3-1
	c0.2-0.6,1-0.9,1.5-0.4C48.6,38.9,48.7,39.3,48.6,39.6z M48.3,19.9c-0.5,0.4-1.3,0.2-1.5-0.4c-0.1-0.4,0-0.8,0.3-1
	c0.5-0.4,1.3-0.2,1.5,0.4C48.7,19.2,48.6,19.6,48.3,19.9z M50.5,30.2c-0.7,0.1-1.3-0.5-1.1-1.1c0.1-0.4,0.4-0.7,0.8-0.8
	c0.7-0.1,1.3,0.5,1.1,1.1C51.2,29.8,50.9,30.1,50.5,30.2z`
  },
  {
    rank: 2,
    factor: "score_cost_of_living",
    displayName: "Cost of Living",
    iconPath: `M52.5,15h-45C6.1,15,5,16.1,5,17.5v25C5,43.9,6.1,45,7.5,45h45c1.4,0,2.5-1.1,2.5-2.5v-25C55,16.1,53.9,15,52.5,15z
       M8.8,41.2v-5c2.8,0,5,2.2,5,5H8.8z M8.8,23.8v-5h5C13.8,21.5,11.5,23.8,8.8,23.8z M30,37.5c-3.5,0-6.2-3.4-6.2-7.5
      c0-4.1,2.8-7.5,6.2-7.5s6.2,3.4,6.2,7.5C36.2,34.1,33.5,37.5,30,37.5z M51.2,41.2h-5c0-2.8,2.2-5,5-5V41.2z M51.2,23.8
      c-2.8,0-5-2.2-5-5h5V23.8z`
  },
  {
    rank: 3,
    factor: "score_economy",
    displayName: "Economy",
    iconPath: `M16.1,2.1c-2,0-3.8,0.4-5,1C9.9,3.7,9.5,4.4,9.5,4.9S9.9,6,11.1,6.6c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8
      s-0.5-1.2-1.7-1.8C19.9,2.5,18.1,2.1,16.1,2.1z M35.4,5.9c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8s0.5,1.2,1.7,1.8
      c1.2,0.6,3,1,5,1c0.5,0,1.1,0,1.6-0.1c0.5-0.7,1.3-1.2,2.1-1.6C40,9.3,41,9,42.1,8.8c0,0,0-0.1,0-0.1c0-0.5-0.5-1.2-1.7-1.8
      C39.2,6.4,37.4,5.9,35.4,5.9z M9.5,8.2v0.6c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0
      c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1V8.2c-0.2,0.1-0.5,0.3-0.7,0.4c-1.6,0.8-3.7,1.2-6,1.2s-4.4-0.4-6-1.2
      C9.9,8.4,9.7,8.3,9.5,8.2z M45.1,10.7c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8c0,0.5,0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1
      s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8c0-0.5-0.5-1.2-1.7-1.8C48.9,11.1,47.1,10.7,45.1,10.7z M28.8,12v0.3c0.4,0.1,0.7,0.3,1,0.4
      c1.1,0.5,2,1.3,2.5,2.3c1.2,0.3,2.6,0.4,4,0.3v-1.7c-0.3,0-0.6,0-0.8,0c-2.3,0-4.4-0.4-6-1.2C29.2,12.3,29,12.2,28.8,12z M9.5,12
      v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c0.8,0.2,1.7,0.4,2.7,0.4c0.2-0.6,0.7-1.2,1.2-1.7c-1.5,0-3.1-0.2-4.5-0.6
      C11,12.8,10.2,12.5,9.5,12z M23.8,13.7c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8s0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1
      c1.2-0.6,1.7-1.3,1.7-1.8s-0.5-1.2-1.7-1.8C27.6,14.1,25.8,13.7,23.8,13.7z M9.5,15.9v0.5c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c0.8,0.2,1.6,0.4,2.5,0.4v-1.7c-1.1-0.1-2.1-0.2-3.1-0.5C11,16.7,10.2,16.3,9.5,15.9L9.5,15.9z M38.5,16.8
      v0.6c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.6
      c-0.2,0.1-0.5,0.3-0.7,0.4c-1.6,0.8-3.7,1.2-6,1.2s-4.4-0.4-6-1.2C38.9,17.1,38.7,16.9,38.5,16.8z M32.7,17.3v1.6
      c1.1,0.2,2.4,0.3,3.6,0.2v-1.7C35.1,17.6,33.8,17.5,32.7,17.3L32.7,17.3z M17.2,19.8v0.6c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.6c-0.2,0.1-0.5,0.3-0.7,0.4
      c-1.6,0.8-3.7,1.2-6,1.2s-4.4-0.4-6-1.2C17.6,20,17.4,19.9,17.2,19.8L17.2,19.8z M9.5,19.8v0.5c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c0.8,0.2,1.6,0.4,2.5,0.4v-1.7c-1.1-0.1-2.1-0.2-3.1-0.5C11,20.6,10.2,20.2,9.5,19.8L9.5,19.8z M38.5,20.6
      v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5
      c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C40,21.4,39.2,21.1,38.5,20.6z M32.7,21.2v1.6c1.1,0.2,2.4,0.3,3.6,0.2v-1.7
      C35.1,21.4,33.8,21.4,32.7,21.2L32.7,21.2z M9.5,23.6v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c0.8,0.2,1.6,0.4,2.5,0.4
      v-1.7c-1.1-0.1-2.1-0.2-3.1-0.5C11,24.4,10.2,24.1,9.5,23.6L9.5,23.6z M17.2,23.6v0.5c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1
      c-2.6,0.8-5.7,0.8-8.3,0C18.7,24.4,17.9,24.1,17.2,23.6z M38.5,24.5v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2
      c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0
      C40,25.3,39.2,25,38.5,24.5z M32.7,25v1.6c1.1,0.2,2.4,0.3,3.6,0.2v-1.7C35.1,25.3,33.8,25.2,32.7,25L32.7,25z M17.2,27.5v0.3
      c0.4,0.1,0.7,0.3,1,0.4c1.1,0.5,2,1.3,2.5,2.3c2.1,0.5,4.7,0.5,6.7-0.1c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5
      c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C18.7,28.3,17.9,27.9,17.2,27.5z M38.5,28.4v0.5c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1
      c-2.6,0.8-5.7,0.8-8.3,0C40,29.2,39.2,28.8,38.5,28.4z M32.7,28.9v1.6c1.1,0.2,2.4,0.3,3.6,0.2v-1.7C35.1,29.2,33.8,29.1,32.7,28.9
      L32.7,28.9z M12.2,29.1c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8s0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1
      c1.2-0.6,1.7-1.3,1.7-1.8s-0.5-1.2-1.7-1.8C16,29.5,14.2,29.1,12.2,29.1z M30.5,31.4c-0.7,0.4-1.5,0.8-2.5,1.1
      c-2.2,0.6-4.7,0.7-6.9,0.3v1.7c2,0.4,4.4,0.4,6.3-0.2c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1V31.4z M38.5,32.2v0.5
      c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.8,2.3,1.2c0.5-0.4,1-0.8,1.6-1.1c0.1-0.1,0.3-0.1,0.4-0.2c-0.9-0.1-1.7-0.2-2.5-0.5
      C40,33,39.2,32.7,38.5,32.2L38.5,32.2z M51.7,32.2c-0.3,0.2-0.7,0.4-1.1,0.6c0.4,0,0.7,0.1,1.1,0.2c0-0.1,0-0.1,0-0.2
      C51.7,32.8,51.7,32.2,51.7,32.2z M32.7,32.8v1.6c0.8,0.2,1.8,0.3,2.8,0.3c0.3,0,0.6,0,0.8,0V33C35.1,33,33.8,33,32.7,32.8L32.7,32.8
      z M49,34.9c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8s0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8
      s-0.5-1.2-1.7-1.8C52.7,35.3,50.9,34.9,49,34.9z M5.6,35.2v0.6c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0
      c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.6c-0.2,0.1-0.5,0.3-0.7,0.4c-1.6,0.8-3.7,1.2-6,1.2s-4.4-0.4-6-1.2
      C6.1,35.5,5.8,35.4,5.6,35.2z M30.5,35.2c-0.7,0.4-1.5,0.8-2.5,1.1c-2.2,0.6-4.7,0.7-6.9,0.3v1.7c2,0.4,4.4,0.4,6.3-0.2
      c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1V35.2z M38.5,36.1v0.5c0,0.5,0.5,1.2,1.7,1.8c0,0,0,0,0,0v-1.5
      C39.5,36.7,39,36.4,38.5,36.1L38.5,36.1z M5.6,39.1v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0
      c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0
      C7.1,39.9,6.3,39.5,5.6,39.1z M21.1,40.5v1.6c0.6,0.1,1.2,0.2,1.9,0.3c0.2-0.6,0.7-1.2,1.2-1.7C23.1,40.7,22.1,40.7,21.1,40.5z
       M31.6,40.7c-2,0-3.8,0.4-5,1c-1.2,0.6-1.7,1.3-1.7,1.8c0,0.5,0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8
      c0-0.5-0.5-1.2-1.7-1.8C35.3,41.1,33.6,40.7,31.6,40.7z M42.3,41v0.6c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2
      c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1V41c-0.2,0.1-0.5,0.3-0.7,0.4c-1.6,0.8-3.7,1.2-6,1.2
      s-4.4-0.4-6-1.2C42.8,41.3,42.5,41.2,42.3,41z M5.6,43v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0
      c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1V43c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C7.1,43.8,6.3,43.4,5.6,43z
       M42.3,44.9v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2
      c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C43.9,45.7,43,45.3,42.3,44.9z M24.9,46.8v0.6
      c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.6
      c-0.2,0.1-0.5,0.3-0.7,0.4c-1.6,0.8-3.7,1.2-6,1.2s-4.4-0.4-6-1.2C25.4,47.1,25.1,47,24.9,46.8z M5.6,46.8v0.5
      c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5
      c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C7.1,47.6,6.3,47.3,5.6,46.8L5.6,46.8z M42.3,48.7v0.5c0,0.3,0.2,0.7,0.7,1.1
      c0.5,0.4,1.3,0.9,2.4,1.2c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1
      c-2.6,0.8-5.7,0.8-8.3,0C43.9,49.6,43,49.2,42.3,48.7L42.3,48.7z M5.6,50.7v0.5c0,0.3,0.2,0.7,0.7,1.1c0.5,0.4,1.3,0.9,2.4,1.2
      c2.2,0.6,5,0.6,7.1,0c1.1-0.3,1.9-0.8,2.4-1.2c0.5-0.4,0.7-0.8,0.7-1.1v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0
      C7.1,51.5,6.3,51.1,5.6,50.7L5.6,50.7z M24.9,50.7v0.5c0,0.5,0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8
      v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C26.5,51.5,25.6,51.1,24.9,50.7L24.9,50.7z M42.3,52.6v0.5
      c0,0.5,0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0
      C43.9,53.4,43,53.1,42.3,52.6L42.3,52.6z M5.6,54.5v0.5c0,0.5,0.5,1.2,1.7,1.8c1.2,0.6,3,1,5,1s3.8-0.4,5-1c1.2-0.6,1.7-1.3,1.7-1.8
      v-0.5c-0.7,0.4-1.5,0.8-2.5,1.1c-2.6,0.8-5.7,0.8-8.3,0C7.1,55.3,6.3,55,5.6,54.5L5.6,54.5z`
  },
  {
    rank: 4,
    factor: "score_education",
    displayName: "Education",
    iconPath: `M14.1,32.8v9.5L30,51.4l15.9-9.1v-9.5L30,41.9L14.1,32.8z M30,8.6L5,22.9l25,14.3l20.5-11.7v16.5H55V22.9L30,8.6z`
  },
  {
    rank: 5,
    factor: "score_environmental_quality",
    displayName: "Environmental Quality",
    iconPath: `M52.4,8.6c-0.5-1.1-1.9-1.1-2.5-0.1c-2.7,4.7-7.5,7.6-13,7.6H30c-9.2,0-16.7,7.5-16.7,16.7c0,0.6,0.1,1.2,0.1,1.8
      c5.5-4,13.5-7.3,24.9-7.3c0.8,0,1.4,0.6,1.4,1.4S39.1,30,38.3,30C16.5,30,7.3,43.4,5.2,48.4c-0.6,1.4,0.1,3,1.5,3.6
      c1.4,0.6,3-0.1,3.6-1.5c0.1-0.3,1.8-4.2,6.2-7.9c2.8,3.8,8.2,7.4,15.2,6.7C45.4,48.4,55,36.1,55,21.2C55,16.8,54.1,12.3,52.4,8.6z`
  },
  {
    rank: 6,
    factor: "score_healthcare",
    displayName: "Healthcare",
    iconPath: `M19.3,28.7v-4.5c0-0.7,0.6-1.3,1.3-1.3h4.5c0.7,0,1.3,0.6,1.3,1.3v4.5c0,0.7-0.6,1.3-1.3,1.3h-4.5
      C19.9,30,19.3,29.4,19.3,28.7z M34.9,30h4.5c0.7,0,1.3-0.6,1.3-1.3v-4.5c0-0.7-0.6-1.3-1.3-1.3h-4.5c-0.7,0-1.3,0.6-1.3,1.3v4.5
      C33.6,29.4,34.2,30,34.9,30z M26.4,39.4v-4.5c0-0.7-0.6-1.3-1.3-1.3h-4.5c-0.7,0-1.3,0.6-1.3,1.3v4.5c0,0.7,0.6,1.3,1.3,1.3h4.5
      C25.8,40.7,26.4,40.1,26.4,39.4z M34.9,40.7h4.5c0.7,0,1.3-0.6,1.3-1.3v-4.5c0-0.7-0.6-1.3-1.3-1.3h-4.5c-0.7,0-1.3,0.6-1.3,1.3v4.5
      C33.6,40.1,34.2,40.7,34.9,40.7z M55,54.6v4H5v-4c0-0.7,0.6-1.3,1.3-1.3h2.2V10.9c0-1.3,1.2-2.3,2.7-2.3h9.9V4.1
      c0-1.5,1.2-2.7,2.7-2.7h12.5c1.5,0,2.7,1.2,2.7,2.7v4.5h9.9c1.5,0,2.7,1.1,2.7,2.3v42.3h2.2C54.4,53.2,55,53.8,55,54.6z M13.9,53.1
      h12.6v-7.5c0-0.7,0.6-1.3,1.3-1.3h4.5c0.7,0,1.3,0.6,1.3,1.3v7.5h12.6V13.9h-7.2v2.7c0,1.5-1.2,2.7-2.7,2.7H23.8
      c-1.5,0-2.7-1.2-2.7-2.7v-2.7h-7.2V53.1z M34.7,8.6h-2.9V5.7c0-0.4-0.3-0.7-0.7-0.7h-2.2c-0.4,0-0.7,0.3-0.7,0.7v2.9h-2.9
      c-0.4,0-0.7,0.3-0.7,0.7v2.2c0,0.4,0.3,0.7,0.7,0.7h2.9V15c0,0.4,0.3,0.7,0.7,0.7h2.2c0.4,0,0.7-0.3,0.7-0.7v-2.9h2.9
      c0.4,0,0.7-0.3,0.7-0.7V9.2C35.4,8.9,35.1,8.6,34.7,8.6z`
  },
  {
    rank: 7,
    factor: "score_housing",
    displayName: "Housing",
    iconPath: `M29.3,20.6l-16,13.2v14.2c0,0.8,0.6,1.4,1.4,1.4l9.7,0c0.8,0,1.4-0.6,1.4-1.4v-8.3c0-0.8,0.6-1.4,1.4-1.4h5.6
      c0.8,0,1.4,0.6,1.4,1.4V48c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0l9.7,0c0.8,0,1.4-0.6,1.4-1.4V33.8l-16-13.2
      C30.3,20.3,29.7,20.3,29.3,20.6z M54.6,29.6l-7.3-6v-12c0-0.6-0.5-1-1-1h-4.9c-0.6,0-1,0.5-1,1v6.3l-7.8-6.4c-1.5-1.3-3.8-1.3-5.3,0
      l-22,18.1c-0.4,0.4-0.5,1-0.1,1.5c0,0,0,0,0,0l2.2,2.7c0.4,0.4,1,0.5,1.5,0.1c0,0,0,0,0,0l20.4-16.8c0.4-0.3,0.9-0.3,1.3,0
      l20.4,16.8c0.4,0.4,1.1,0.3,1.5-0.1c0,0,0,0,0,0l2.2-2.7C55.1,30.6,55.1,30,54.6,29.6C54.6,29.6,54.6,29.6,54.6,29.6z`
  },
  {
    rank: 8,
    factor: "score_internet_access",
    displayName: "Internet",
    iconPath: `M54.6,20.7C40.8,7.9,19.2,7.9,5.4,20.7c-0.5,0.5-0.5,1.3,0,1.8L8,25.1c0.5,0.5,1.3,0.5,1.8,0c11.4-10.4,29-10.4,40.4,0
      c0.5,0.5,1.3,0.4,1.8,0l2.7-2.7C55.1,22,55.1,21.2,54.6,20.7z M30,36.1c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5s5-2.2,5-5
      C35,38.3,32.8,36.1,30,36.1z M45.8,29.6c-9-8-22.7-8-31.7,0c-0.5,0.5-0.6,1.3,0,1.8l2.7,2.7c0.5,0.5,1.2,0.5,1.7,0.1
      c6.6-5.7,16.4-5.7,22.9,0c0.5,0.4,1.3,0.4,1.7-0.1l2.7-2.7C46.4,30.9,46.4,30,45.8,29.6z`
  },
  {
    rank: 9,
    factor: "score_leisure_&_culture",
    displayName: "Leisure and Culture",
    iconPath: `M5.3,10.8l0,1.8h49.4v-1.8L5.3,10.8L5.3,10.8z M5.3,14.5l0,4.9H6C6,17.5,7.5,16,9.3,16s3.3,1.5,3.3,3.3h1.7c0,0,0,0,0-0.1
      c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3c0,0,0,0,0,0.1h1.6c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3h1.7c0,0,0,0,0-0.1
      c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3c0,0,0,0,0,0.1h1.7c0,0,0-0.1,0-0.1c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3
      c0,0,0,0.1,0,0.1h1.7c0-0.1,0-0.1,0-0.2c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3c0,0.1,0,0.1,0,0.2h0.7v-4.9H5.3z M5.1,21l0,10H6
      c0.2-4.2,1.6-7.5,3.3-7.5c1.7,0,3.1,3.2,3.3,7.5h1.7c0.2-4.2,1.6-7.5,3.3-7.5c1.7,0,3.1,3.2,3.3,7.5h1.7c0.2-4.2,1.6-7.5,3.3-7.5
      c1.7,0,3.1,3.2,3.3,7.5h1.7c0.2-4.2,1.6-7.5,3.3-7.5c1.7,0,3.1,3.2,3.3,7.5h1.7c0.2-4.2,1.6-7.5,3.3-7.5c1.7,0,3.1,3.2,3.3,7.5h1.7
      c0.2-4.2,1.6-7.5,3.3-7.5c1.7,0,3.1,3.2,3.3,7.5h0.8l0-10C54.9,21,5.1,21,5.1,21z M5,32.6l0.1,16.6h2.7c0.1-8.1,3-14.7,6.5-14.7
      c3.6,0,6.5,6.5,6.5,14.7h2.7c0.2-7.9,3.1-14.1,6.5-14.1c3.5,0,6.3,6.2,6.5,14.1h2.7c0.2-7.9,3.1-14.1,6.5-14.1
      c3.5,0,6.3,6.2,6.5,14.1h2.6L55,32.6H5L5,32.6z`
  },
  {
    rank: 10,
    factor: "score_outdoors",
    displayName: "Outdoors",
    iconPath: `M39.9,4.3c-1.5,3.2-3.1,6.4-6.5,8.9c0.8,0.4,2.2,0.6,2.9,0.9c-1.3,2-3.5,3.8-5.4,5.5c1.2,0.6,2.3,1.1,3.5,1.5
      c-1.5,2.3-3.2,4.5-5.4,6.5c1.7,1,3.5,1.7,5.2,2.3c-1.9,2.7-4.2,5.2-7.6,8c5.4,2.8,10.2,4.1,14.9,3.9c0.2,0,0.4,0,0.6,0v0
      c4.2-0.2,8.3-1.6,12.9-4c-4.1-2.6-6.6-5-8.5-7.7c1.9-0.5,3.7-1.4,5.6-2.4c-2.7-1.9-4.6-4-6.2-6.4c1.3-0.4,2.5-0.9,3.8-1.6
      c-2.4-1.5-4.6-3.4-5.9-5.4c0.9-0.3,2.4-0.6,3.3-1C43,11.1,41.9,7.8,39.9,4.3z M21.4,36.1c0,0,0,0.1-0.1,0.1l2,14.6l7.6,0.1
      C26.9,46.2,24,41.4,21.4,36.1z M21.3,36.3c-2.5,5-4.7,9.9-9.1,14.4l8.1,0.1L21.3,36.3z M19.1,36.4c-2.5,0.9-5.7,1.8-8.6,1.7
      C9.3,42.2,7.7,46.4,5,50.2l4.9,0.2C14.4,46.1,16.6,41.4,19.1,36.4z M38.7,43.6L38.4,51l4.5,0.1l-0.6-7.3
      C41,43.7,39.8,43.7,38.7,43.6z`
  },
  {
    rank: 11,
    factor: "score_safety",
    displayName: "Safety",
    iconPath: `M26.7,8.8L5.5,47.7c-1.3,2.4,0.4,5.4,3.3,5.4h42.6c2.8,0,4.6-3,3.3-5.4L33.3,8.8C31.8,6.3,28.1,6.3,26.7,8.8z M32.1,25
      l-0.4,14.7h-3.4L27.9,25H32.1z M30,47.6c-1.3,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2s2.3,1,2.3,2.2C32.3,46.6,31.3,47.6,30,47.6z`
  },
  {
    rank: 12,
    factor: "score_startups",
    displayName: "Startups",
    iconPath: `M54.3,6.9c-0.1-0.6-0.6-1.1-1.2-1.2C50,5,47.5,5,45.1,5C35,5,29,10.4,24.4,17.5H14.3c-1.8,0-3.4,1-4.2,2.6l-4.8,9.7
      c-0.6,1.2-0.1,2.6,1.1,3.1c0.3,0.2,0.7,0.2,1,0.2h10.1l-2.2,2.2c-1.2,1.2-1.2,3.2,0,4.4l5,5c1.2,1.2,3.2,1.2,4.4,0c0,0,0,0,0,0
      l2.2-2.2v10.1c0,1.3,1,2.3,2.3,2.3c0.4,0,0.7-0.1,1-0.2l9.6-4.8c1.6-0.8,2.6-2.4,2.6-4.2V35.5C49.6,31,55,25,55,14.9
      C55,12.5,55,10,54.3,6.9z M42.5,21.4c-2.2,0-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9c2.2,0,3.9,1.7,3.9,3.9S44.7,21.4,42.5,21.4z`
  },
  {
    rank: 13,
    factor: "score_taxation",
    displayName: "Taxation",
    iconPath: `M55,9.8v40.4c0,2.7-2.1,4.8-4.8,4.8H9.8C7.2,55,5,52.9,5,50.2V9.8C5,7.1,7.1,5,9.8,5h40.4C52.9,5,55,7.1,55,9.8z M50.8,50.2
      V9.8c0-0.3-0.3-0.6-0.6-0.6h-1l-12.3,8.3L30,11.9l-6.8,5.6L10.9,9.2h-1c-0.4,0-0.6,0.3-0.6,0.6v40.4c0,0.3,0.3,0.6,0.6,0.6h40.4
      C50.5,50.8,50.8,50.5,50.8,50.2z M21.8,22.2v4.1h-8.2v-4.1H21.8z M21.8,30.5v4.2h-8.2v-4.2H21.8z M23,14l6-4.9H15.8L23,14z
       M46.4,22.2v4.1H24.6v-4.1H46.4z M46.4,30.5v4.2H24.6v-4.2H46.4z M37,14l7.2-4.9H31C31,9.2,37,14,37,14z M46.4,38.8V43H35.3v-4.2
      H46.4z`
  },
  {
    rank: 14,
    factor: "ranked_population",
    displayName: "Population",
    iconPath: `M39.1,26.4c3.7,0,6.8-3,6.8-6.7c0-3.7-3.1-6.7-6.8-6.7c-3.7,0-6.8,3-6.8,6.7C32.3,23.4,35.3,26.4,39.1,26.4z M20.9,26.4
      c3.7,0,6.8-3,6.8-6.7c0-3.7-3.1-6.7-6.8-6.7s-6.8,3-6.8,6.7C14.1,23.4,17.2,26.4,20.9,26.4z M20.9,31.3C15.6,31.3,5,33.9,5,39.1v6
      h32.1v-6C37.1,33.9,26.3,31.3,20.9,31.3z M39.1,32.5c-0.7,0-1.2,0-1.9,0.1c2.6,1.9,3.6,3.1,3.6,6.5v6H55v-6
      C55,33.9,44.4,32.5,39.1,32.5z`
  }
];

/* For Landing Page Factors */
export const landingFactors = factors.filter((qf, i) => i < 7);

//Add the More Icon to Landing Page Factors
landingFactors.push({
  factor: "More",
  displayName: "More",
  iconPath: `M29.7,25.1c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S32.4,25.1,29.7,25.1z M9.6,25.1c-2.7,0-4.9,2.2-4.9,4.9
s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S12.4,25.1,9.6,25.1z M49.8,25.1c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9
S52.5,25.1,49.8,25.1z`
});

//More Icon to be used on city card (but rotated 90deg)
export const moreIcon = {
  factor: "More",
  displayName: "More",
  iconPath: `M29.7,25.1c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S32.4,25.1,29.7,25.1z M9.6,25.1c-2.7,0-4.9,2.2-4.9,4.9
  s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S12.4,25.1,9.6,25.1z M49.8,25.1c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9
  S52.5,25.1,49.8,25.1z`
};

/* For Add Filter - Modal */
const categories = {
  Affordability: [12, 3, 2, 13],
  "Quality of Life": [9, 10, 8, 4],
  People: [7, 14, 1],
  "Well Being": [11, 5, 6]
};

export const categoriesWithFactors = {};

Object.keys(categories).forEach(category => {
  if (!categoriesWithFactors[category]) {
    categoriesWithFactors[category] = [];
  }
  categories[category].forEach(factorIndex => {
    categoriesWithFactors[category].push(factors[factorIndex - 1]);
  });
});

/* 
https://medium.com/@david.gilbertson/icons-as-react-components-de3e33cb8792
React Icon Names for Each Factor
"Commute Time"               IoIosClock
"Cost of Living"             FaMoneyBill
"Economy"                    GiCoins
"Education"                 IoMdSchool
"Environmental Quality"     FaLeaf
"Healthcare"                FaRegHospital
"Housing"                  FaHome
"Internet"                     FaWifi
"Leisure and Culture"       GiAqueduct
"Outdoors"                  GiForestCamp
"Safety"                  IoIosWarning
"Startups"                IoIosRocket
"Taxation"              FaWpforms
"Population"               IoMdPeople
"More"                      IoIosMore
*/

//Used for random factor to be displayed on top cities on landing page
export const randomFactor = factors => {
  return factors[Math.floor(Math.random() * factors.length)];
};
